export default {
  getCampaign: state => state.campaign,
  getUpdateCv: state => state.updateCv
}
